import React from "react";
import Header from "./Header";
import PqrsdForm from "../pqrsd/PqrsdForm";

export default function LayoutPqrsdWindow() {
  return (
    <>
      <Header />
      <PqrsdForm variant="window" />
    </>
  );
}
